module.exports = __webpack_public_path__ + "static/ed-bodensiek-d3b92321eee930b4fd19ac568552104d.jpg";